// Local-preview-only shim. `cloudflare:workers` only exists on real Workers
// runtime; this lets `vite dev` render pages locally with DB features
// gracefully degraded (bindings.server.ts already guards for a missing DB).
export const env = {};
